import React, { lazy } from 'react'
import { useSearchParams } from 'react-router-dom'

import { NotificationActionTrigger } from '@makyoapp/makyo-sdk/models/Notifications'

import { NewOrgTeamModalForm } from './components/NewOrgTeamModalForm'
import { useOrgsContext } from './context/OrgsContext'
import { useAddOrgCb } from './hooks/useAddOrgCb'
import useAuth from './hooks/useAuth'
import { useReqNotif } from './hooks/useReqNotif'
import { lazyModal } from './lib/lazy-load'
import { INVITATION_ACTION_KEY } from './shared/constants'

const OnBoardingModal = lazyModal(() => import('@/components/OnBoardingModal'))
const InvitationModal = lazyModal(() => import('@/components/InvitationModal'))
const OwnershipInvitationModal = lazyModal(() => import('@/components/OwnershipInvitationModal'))

/**
 * App global modals.
 * all of these modals should be lazyloaded, internally or not.
 */
export default function AppModals() {
  const { userData } = useAuth()
  const { setShowCreateOrg, showCreateOrg } = useOrgsContext()
  const [searchParams] = useSearchParams()
  const isInvite = searchParams.get(INVITATION_ACTION_KEY) as NotificationActionTrigger | null

  const { show: showInvitationModal } = useReqNotif(NotificationActionTrigger.OrganizationMemberInvite)
  const { show: showOwnershipInvitationModal } = useReqNotif(NotificationActionTrigger.ChangingOrgOwnership)

  const handleAddOrg = useAddOrgCb(() => {
    setShowCreateOrg(false)
  })

  const showOnboardingModal = !userData?.name && isInvite === null

  return (
    <React.Suspense fallback={null}>
      <OnBoardingModal show={showOnboardingModal} />

      <InvitationModal show={showInvitationModal} />

      <OwnershipInvitationModal show={showOwnershipInvitationModal} />

      <NewOrgTeamModalForm
        formId='new-org'
        onSubmit={handleAddOrg}
        onHide={() => setShowCreateOrg(false)}
        show={showCreateOrg}
      />
    </React.Suspense>
  )
}
